import React from "react";
import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import useStyles from "./styles";

export const CategoryFormBasicInfo: React.FC = () => {
  const { control } = useFormContext();
  const classes = useStyles();

  return (
    <Controller
      name="title"
      control={control}
      rules={{
        required: "Champ obligatoire",
      }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          id="reference"
          variant="outlined"
          className={classes.TextField}
          placeholder="Tapez le nom de la catégorie"
          {...field}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};
